"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M10 8.64 15.27 12 10 15.36zM8 5v14l11-7z"
}), 'PlayArrowOutlined');